import React from 'react';
import { POWERED_BY_SNOWFLAKE } from '../../../content/enterpriseMessaging';

/** Subtle Powered by Snowflake logo: professional sizing, optional alignment. */
export default function PoweredBySnowflake({
  className = 'h-5 w-auto object-contain shrink-0',
  align = 'center',
  inline = false,
}) {
  const img = (
    <img
      src={POWERED_BY_SNOWFLAKE.src}
      alt={POWERED_BY_SNOWFLAKE.alt}
      loading="lazy"
      className={className}
    />
  );

  if (inline) return img;

  const justify =
    align === 'start' ? 'justify-start' : align === 'end' ? 'justify-end' : 'justify-center';

  return <div className={`flex ${justify}`}>{img}</div>;
}
